import { render, staticRenderFns } from "./AddressBox.vue?vue&type=template&id=62f61304&scoped=true"
import script from "./AddressBox.vue?vue&type=script&lang=js"
export * from "./AddressBox.vue?vue&type=script&lang=js"
import style0 from "./AddressBox.vue?vue&type=style&index=0&id=62f61304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f61304",
  null
  
)

export default component.exports